import { Menu, MenuButton, IconButton, MenuList, MenuItem, Box, useDisclosure, } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
import KebabMenuIcon from '../../icons/KebabIcon/KebabIcon';
import { RenderIf } from '../RenderIf/RenderIf';
import { useManyDisclosureProxy } from '../../../hooks/state/useManyDisclosureProxy';
import { localise } from '../../../services/lang/lang';
import { ResendRemoteSubmissionInviteModalWrapper } from './ResendRemoteSubmissionInviteModalWrapper';
import { DeleteRemoteSubmissionInviteModalWrapper } from './DeleteRemoteSubmissionInviteModalWrapper';
import { buildClickAndKeyDownEvents } from '../../../services/utils';
const RemoteSubmissionInvitesActionMenu = ({ invite, onMutated, onInviteResent, }) => {
    const tokens = useTokens();
    const { buildOnOpen, isOpen, buildOnClose } = useManyDisclosureProxy({
        resendInviteModal: useDisclosure(),
        revokeInviteModal: useDisclosure(),
    });
    const actions = [
        {
            label: localise('RESEND_INVITE'),
            testId: 'remote_submission_invites_action_menu__resend',
            onClick: buildOnOpen('resendInviteModal'),
        },
        {
            label: localise('REVOKE_INVITE'),
            testId: 'remote_submission_invites_action_menu__revoke',
            onClick: buildOnOpen('revokeInviteModal'),
        },
    ];
    return (React.createElement(Box, null,
        React.createElement(Menu, null,
            React.createElement(MenuButton, { onClick: (e) => e.stopPropagation(), onKeyDown: (e) => e.stopPropagation(), as: IconButton, "data-testid": "remote_submission_invites_action_menu__kebab_button", colorScheme: tokens.Layer01, icon: React.createElement(KebabMenuIcon, null), "aria-label": localise('INVITE_ACTIONS') }),
            React.createElement(MenuList, null, actions.map((action) => (React.createElement(MenuItem, { "data-testid": action.testId, ...buildClickAndKeyDownEvents(() => action.onClick?.()), tabIndex: 0, key: action.label }, action.label))))),
        React.createElement(RenderIf, { condition: isOpen('resendInviteModal') },
            React.createElement(ResendRemoteSubmissionInviteModalWrapper, { invite: invite, onSuccess: onInviteResent, onClose: buildOnClose('resendInviteModal') })),
        React.createElement(RenderIf, { condition: isOpen('revokeInviteModal') },
            React.createElement(DeleteRemoteSubmissionInviteModalWrapper, { invite: invite, onMutated: onMutated, onClose: buildOnClose('revokeInviteModal') }))));
};
export default RemoteSubmissionInvitesActionMenu;
